import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Pasé de pasarme el domingo entero planificando a terminar todo en una hora. No puedo creer que no lo haya descubierto antes.',
  name: 'María Laura G.',
  role: 'Docente de Primaria',
  city: 'Córdoba'
}, {
  quote: 'Compré muchos packs de PDFs antes de esto y ninguno me sirvió. Este sistema es completamente diferente porque aprendés a hacerlo vos misma.',
  name: 'Claudia R.',
  role: 'Profesora de Secundaria',
  city: 'Buenos Aires'
}, {
  quote: 'Al principio dudé porque no soy muy tecnológica. Pero el manual está tan bien explicado que lo usé desde el primer día sin problemas.',
  name: 'Patricia M.',
  role: 'Docente de Inicial',
  city: 'Rosario'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-zinc-950 border-t border-zinc-900" data-id="element-289">
      <div className="max-w-6xl mx-auto px-4" data-id="element-290">
        <div className="text-center mb-16" data-id="element-291">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black uppercase tracking-tight text-white" data-id="element-292">
            Lo que Dicen los Docentes
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-293">
          {TESTIMONIALS.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-zinc-900 border-l-4 border-yellow-500 rounded-r-xl p-8 flex flex-col h-full" data-id="element-294">
              <div className="flex gap-1 text-yellow-500 mb-6" data-id="element-295">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-296" />)}
              </div>

              <p className="text-gray-300 italic mb-8 flex-grow leading-relaxed" data-id="element-297">
                "{test.quote}"
              </p>

              <div className="pt-6 border-t border-zinc-800" data-id="element-298">
                <p className="font-bold text-white mb-1" data-id="element-299">{test.name}</p>
                <p className="text-sm text-gray-500" data-id="element-300">
                  {test.role}, {test.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}